module.exports = __webpack_public_path__ + "static/img/PVC Film_clear film_deskstop.a4b53529.jpg";